import { graphql, useStaticQuery } from "gatsby"

export const useSiteQuery = () => {
  const { contentfulDigitupGlobalSite } = useStaticQuery(graphql`
    query {
      contentfulDigitupGlobalSite(
        id: { eq: "8286039d-1b4c-58a5-9f32-8e889e8d440d" }
      ) {
        headerLogo {
          title
          gatsbyImageData
          height
          width
          file {
            url
          }
        }
        footerLogo {
          title
          gatsbyImageData
          height
          width
          file {
            url
          }
        }
        headerButton {
          ...componentLink
        }
        headerItems {
          __typename
          ...componentHeaderLink
        }
        footerCopyrightItems {
          __typename
          ...componentLink
        }
        subscribeNewsletter
        footerPrivacy {
          footerPrivacy
        }
        headerBlogMedia {
          name
          slider {
            image1 {
              gatsbyImageData
              title
            }
            image2 {
              gatsbyImageData
              title
            }
            content
          }
        }
        footerItems {
          __typename
          ... on ContentfulComponentLinkGroup {
            title
            sections {
              title
              target {
                ...linkTarget
              }
              slug
              image {
                gatsbyImageData
              }
            }
          }
        }
        footerCopyrightText
        contactUsTermsConditions {
          raw
        }
        searchPageAllTags {
          ... on ContentfulComponentLink {
            title
          }
        }
        applyJobHeroImage {
          ...sectionHeroWithText
          ...sectionHeroAlternateText
        }
        jobOverviewImage {
          ...sectionHiring
        }
        thankYouHeroImage {
          ...sectionHeroWithText
          ...sectionHeroAlternateText
        }
        pageContactSection {
          ...sectionHeroWithText
          ...sectionHeroAlternateText
        }
        contactUsFaq {
          ...sectionAccordion
        }
        privacyHeroImage {
          ...sectionHeroWithText
          ...sectionHeroAlternateText
        }
        privacyContent {
          raw
        }
        quoteSection {
          ...componentLink
        }
        headerBlogTitle
        quoteSectionTitle
        contactUsDropdownFields {
          interestedInOptions
          countries
        }
      }
    }
  `)

  return contentfulDigitupGlobalSite
}
